<img [src]="imageUrl()" [alt]="alt()" (error)="handleImageError()" class="block w-full h-full object-cover object-center">
